import { z } from "zod";

import { initContract } from "./base";

const c = initContract();

export const testCronCleanupSandboxesStateActionBodySchema = z
  .object({
    action: z.enum([
      "seed-run",
      "seed-run-ownership",
      "attach-run-thread",
      "delete-run",
      "delete-run-ownership",
      "delete-run-thread",
      "seed-runner-job",
      "seed-custom-connector-auth-ref",
      "seed-queue-entry",
      "seed-queue-marker",
      "seed-export-job",
      "delete-export-job",
      "get-run",
      "get-run-ownership",
      "get-runner-job",
      "get-custom-connector-auth-ref",
      "get-queue-entry",
      "get-queue-marker-revoker",
      "get-export-job",
    ]),
  })
  .passthrough();

export const testCronCleanupSandboxesStateActionResponseSchema = z
  .object({
    ok: z.literal(true),
  })
  .passthrough();

export const testCronCleanupSandboxesStateErrorSchema = z.object({
  error: z.string(),
});

export const testCronCleanupSandboxesStateContract = c.router({
  action: {
    method: "POST",
    path: "/api/test/cron-cleanup-sandboxes-state/action",
    body: testCronCleanupSandboxesStateActionBodySchema,
    responses: {
      200: testCronCleanupSandboxesStateActionResponseSchema,
      400: testCronCleanupSandboxesStateErrorSchema,
      404: z.string(),
    },
    summary: "Mutate or inspect cron cleanup sandboxes test state",
  },
});

export type TestCronCleanupSandboxesStateActionBody = z.infer<
  typeof testCronCleanupSandboxesStateActionBodySchema
>;
export type TestCronCleanupSandboxesStateActionResponse = z.infer<
  typeof testCronCleanupSandboxesStateActionResponseSchema
>;
export type TestCronCleanupSandboxesStateContract =
  typeof testCronCleanupSandboxesStateContract;
